import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

const navigationItems = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Topics', to: '/topics' },
  { label: 'Psychology of Control', to: '/control' },
  { label: 'Types of Manipulators', to: '/types-of-manipulators' },
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="siteHeader">
      <nav className="siteNavigation" aria-label="Primary navigation">
        <Link
          to="/"
          className="siteBrand"
          onClick={closeMobileMenu}
        >
          <span className="brandTitle">
            Psychological Manipulation
          </span>

          <span className="brandDescriptor">
            Behavior · Power · Control
          </span>
        </Link>

        <button
          type="button"
          className="navigationToggle"
          aria-expanded={isMobileMenuOpen}
          aria-controls="primary-navigation"
          aria-label={
            isMobileMenuOpen
              ? 'Close navigation menu'
              : 'Open navigation menu'
          }
          onClick={() =>
            setIsMobileMenuOpen((isOpen) => !isOpen)
          }
        >
          <span aria-hidden="true">
            {isMobileMenuOpen ? '×' : '☰'}
          </span>
        </button>

        <div
          id="primary-navigation"
          className={`navigationLinks ${
            isMobileMenuOpen ? 'navigationLinksOpen' : ''
          }`}
        >
          {navigationItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              onClick={closeMobileMenu}
              className={({ isActive }) =>
                isActive
                  ? 'navigationLink navigationLinkActive'
                  : 'navigationLink'
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;